import { addDays } from 'utils/dateTimes';
import type { IUpcomingMenu } from 'models/UpcomingMenu';
import { ArrivingStatus } from 'models/UpcomingMenu';

/**
 * Returns the next delivery date for the provided addressId. If no
 * addressId is provided, returns date of the first scheduled menu.
 */
const getNextDeliveryDate = (
  upcomingMenus: IUpcomingMenu[],
  addressId?: number,
) => {
  const nextUpcomingMenu = upcomingMenus.find((attributes) => (
    attributes.arriving_status === ArrivingStatus.SCHEDULED
    && (addressId ? attributes.shipping_address.id === addressId : true)
  ));

  if (nextUpcomingMenu) {
    return new Date(nextUpcomingMenu.delivery_on);
  }

  const menuCount = upcomingMenus.length;

  if (!menuCount) return undefined;
  return addDays(upcomingMenus[menuCount - 1].delivery_on, 7);
};

function useNextDeliveryDate(): typeof getNextDeliveryDate {
  return getNextDeliveryDate;
}

export default useNextDeliveryDate;
